import types from './types';
import { get } from 'utils/api';

// Загрузка вендоров
const loadPartnersStart = () => ({
  type: types.LOAD_PARTNERS_REQUEST,
});

const loadPartnersDone = data => ({
  type: types.LOAD_PARTNERS_SUCCESS,
  data,
});

const loadPartners = query => dispatch => {
  dispatch(loadPartnersStart());

  return get({
    url: '/partners',
    data: {
      title: query.title || '',
      sort: query.sort || '-sort',
      category: query.category || '',
      offset: ((query.page ? Number(query.page) : 1) - 1) * 5,
    },
  }).then(data => {
    return dispatch(loadPartnersDone(data));
  });
};

export const loadPartnersIfNotLoaded = query => (dispatch, getState) => {
  const { partners } = getState();
  const { isLoading, isLoaded } = partners;

  if (!isLoaded && !isLoading) {
    return dispatch(loadPartners(query));
  } else {
    return false;
  }
};

// Загрузка партнера по slug
const loadPartnerStart = slug => ({
  type: types.LOAD_PARTNER_REQUEST,
  slug,
});

const loadPartnerDone = (slug, vendor) => ({
  type: types.LOAD_PARTNER_SUCCESS,
  slug,
  vendor,
});

const loadPartnerFailure = (slug, error) => ({
  type: types.LOAD_PARTNER_FAILURE,
  slug,
  error,
});

const loadPartner = slug => dispatch => {
  dispatch(loadPartnerStart(slug));

  return get({ url: `/partners/${slug}` })
    .then(partner => dispatch(loadPartnerDone(slug, partner)))
    .catch(error => {
      dispatch(loadPartnerFailure(slug, error));
      return Promise.reject(error);
    });
};

export const loadPartnerIfNotLoaded = (slug, query) => (dispatch, getState) => {
  const pages = getState().partners.pages;
  const { isLoading, isLoaded } = pages[slug] || {};

  if (!isLoading) {
    return dispatch(async () => {
      if (!isLoaded) {
        await dispatch(loadPartner(slug));
      }
      await dispatch(loadJobs(slug, query));
    });
  } else {
    return null;
  }
};

// Подгрузка статей
const loadJobsRequest = slug => ({
  type: types.LOAD_JOBS_REQUEST,
  slug,
});

const loadJobsSuccess = (slug, data) => ({
  type: types.LOAD_JOBS_SUCCESS,
  slug,
  data,
});

const loadJobsFailure = (slug, error) => ({
  type: types.LOAD_JOBS_FAILURE,
  slug,
  error,
});

/** Запрос на подгрузку
 * @param {string} slug
 * @param {string} category
 * @param {number} page
 * @param {string} sort
 * @param {number} total
 */
export const loadJobs = (slug, query) => (dispatch, getState) => {
  const isLoadingJobs = getState().partners.pages[slug].isLoadingJobs;

  if (!isLoadingJobs) {
    dispatch(loadJobsRequest(slug));

    return get({
      url: `/job-partners/${slug}`,
      data: {
        page: query.page || 1,
        sort: query.sort,
        total: query.total,
        title: query.title,
        skill: query.skill,
        tool: query.tool,
        style: query.style,
      },
    })
      .then(({ skills, tools, styles, jobs }) =>
        dispatch(
          loadJobsSuccess(slug, {
            total: jobs.total,
            items: jobs.items,
            skills,
            tools,
            styles,
          }),
        ),
      )
      .catch(error => dispatch(loadJobsFailure(slug, error)));
  } else {
    return null;
  }
};

// Подгрузка статей
const loadArticlesRequest = () => ({
  type: types.LOAD_ARTICLES_REQUEST,
});

const loadArticlesSuccess = (slug, items) => ({
  type: types.LOAD_ARTICLES_SUCCESS,
  slug,
  items,
});

const loadArticlesFailure = (slug, error) => ({
  type: types.LOAD_ARTICLES_FAILURE,
  slug,
  error,
});

/** Запрос на подгрузку
 * @param {string} slug
 * @param {object} data - Данные запросп
 * @returns {Promise | null}
 */
export const loadArticles = (slug, data) => (dispatch, getState) => {
  const {
    partners: { isLoadingArticles },
    profile,
  } = getState();

  const consumerId = profile.id;
  const headers = consumerId ? { ['X-Consumer']: consumerId } : {};

  if (!isLoadingArticles) {
    dispatch(loadArticlesRequest());

    return get({ url: '/articles/list', data, headers })
      .then(res => dispatch(loadArticlesSuccess(slug, res.items)))
      .catch(error => dispatch(loadArticlesFailure(slug, error)));
  } else {
    return null;
  }
};
